import React from 'react'
import LabeledValue from '../../../components/common/LabeledValue'
import { formatDateTimeWithTimezoneAndSeconds, formatDateToMMDDYY } from '../../../utils/date'

interface ApproverStatusRightPanelProps {
  timeOffRequestFor: string
  timeOffRequestDates: string
  timeOffRequestId: string
  submittedOn: string
  submittedBy: string
  employeeComments: string | undefined | null
  manualRequestedDate: string | undefined | null
  /** Prints only the request details/summary/audit history/calendar, matching legacy's print scope. Falls back to a full-page print if not provided. */
  onPrint?: () => void
}

/**
 * ApproverStatusRightPanel — renders request details in a blue background panel
 * following the requestor page RightPanel design pattern
 */
const ApproverStatusRightPanel: React.FC<ApproverStatusRightPanelProps> = ({
  timeOffRequestFor,
  timeOffRequestDates,
  timeOffRequestId,
  submittedOn,
  submittedBy,
  employeeComments,
  manualRequestedDate,
  onPrint,
}) => {
  return (
    <div className="flex-1 flex flex-col">
      <div className="p-4! bg-[#F2F8FB] rounded-3xl">
        <div className="mb-6">
          <LabeledValue label="Time Off Request For" value={timeOffRequestFor} />
        </div>

        <div className="mb-6">
          <LabeledValue label="Time Off Request Dates" value={timeOffRequestDates} />
        </div>

        <div className="mb-6">
          <LabeledValue label="Time Off Request ID" value={timeOffRequestId} />
        </div>

        <div className="mb-6">
          <LabeledValue label="Submitted On" value={formatDateTimeWithTimezoneAndSeconds(submittedOn)} />
        </div>

        <div className="mb-6">
          <LabeledValue label="Submitted By" value={submittedBy} />
        </div>
        {manualRequestedDate && (
        <div className="mb-6">
          <LabeledValue
            label="Date Manual Request Received"
            value={manualRequestedDate ? formatDateToMMDDYY(manualRequestedDate) : ''}
          />
        </div>)}
        <div className="mb-6">
          <LabeledValue label="Employee Comments" value={employeeComments ?? ""} />
        </div>
      </div>

      <div className="flex justify-start mt-4!">
        <button type='button' className="button -primary flex items-center gap-1" onClick={onPrint ?? (() => globalThis.print())}>
          <img src="/assets/images/printer-outline.svg" alt="Print" className="w-7 h-7" />
          <span className="align-middle">Print</span>
        </button>
      </div>
    </div>
  )
}

export default ApproverStatusRightPanel
